import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from     "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class SoutCards extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            inOperation: true,
            showHistory: false
        }
    }
    componentDidMount() {
        this.initialize();
    }
    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem_List.execute({IsShowHist: (this.state.showHistory ? 1 : 0)}, {
                withParams: false,
                newItem: true
            }));
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }
    renderButtons = () => {
        let currentRow = null;
        let currentRowKey = null;
        if(this.props.dataItem_List.rowsCount() === 1){
            currentRow = this.props.dataItem_List.getRow(0);
            currentRowKey = this.props.dataItem_List.getRowKey(currentRow);
        }
        return (<div className="row mb-1">
            <div className="col-md-3">
                <label className="form-check-label text-color" htmlFor="checkShowHistory">
                    {i18next.t("Show_History")}:
                </label>
                &nbsp;
                <input type="checkbox" className="checkbox align-baseline" checked={this.state.showHistory}
                       id="checkShowHistory"
                       style={{cursor: "pointer"}} onChange={() => {
                    this.setState({showHistory: !this.state.showHistory}, this.refreshList);
                }}/>
            </div>
            {
                currentRow && currentRow._IsCan_Sign === 1 &&
                <div className="col-md-2">
                    <button type="button" className="btn btn-regular -goahead ml1ex"
                            onClick={() => this.signCard(currentRowKey)}>{i18next.t("WasAcquainted")}</button>
                </div>
            }
            {
                currentRow && currentRow._IsCan_UnSign === 1 &&
                <div className="col-md-3">
                    <button type="button" className="btn btn-regular ml1ex"
                            onClick={() => this.unSignCard(currentRowKey)}>{i18next.t("WasNotAcquainted")}</button>
                </div>
            }
        </div>)
    }
    refreshList = async () => {
        await this.props.dispatch(this.props.dataItem_List.refresh({IsShowHist: (this.state.showHistory ? 1 : 0)}));
    }
    signCard = async (rowKey) => {
        await this.props.dispatch(this.props.dataItem_SignCard.execute(rowKey));
        await this.refreshList();
    }
    unSignCard = async (rowKey) => {
        await this.props.dispatch(this.props.dataItem_UnSignCard.execute(rowKey));
        await this.refreshList();
    }
    /*renderCellEx = (cellParams) => {
        const rowKey = cellParams.dataItem.getRowKey(cellParams.row);
        if (cellParams.fieldInfo.Name === "RowActions") {
            return (<div>
                {
                    cellParams.row._IsCan_Sign === 1 &&
                    <button className="btn" type="button" style={{color: "#bd2130"}} title={i18next.t("Подписать")}>
                        <i className="fa fa-info-circle ml-2 gridcell-tooltip"
                           onClick={() => this.signCard(rowKey)}/>&nbsp;
                    </button>
                }
                {
                    cellParams.row._IsCan_UnSign === 1 &&
                    <button className="btn" type="button" style={{color: "brown"}}
                            title={i18next.t("Отозвать")}>
                        <i className="fas fa-paper-plane fa-lg" onClick={() => this.unSignCard(rowKey)}/>&nbsp;
                    </button>
                }
            </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }*/
    rowClick = async (rowIndex, row) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "SoutCards", "GetCardScan") + "?" + $.param({
            b_token: token,
            id: row.RateCardIntId
        });
        window.open(downloadPath, '_blank');
    }
    render() {
        return (
            <React.Fragment>
                <PlaceholderWrapper placeholderId="10" title={i18next.t("Sout_Cards_1")}
                                    showInstruction={false}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    {this.renderButtons()}
                    <GridView dataItem={this.props.dataItem_List}
                              rowCursor="pointer"
                              onRowClick={this.rowClick}
                    />
                </PlaceholderWrapper>
            </React.Fragment>)
    }
}
SoutCards.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_List: PropTypes.object,
    dataItem_SignCard: PropTypes.object,
    dataItem_ViewCard: PropTypes.object
}
SoutCards.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        dataItem_List: state.soutState.RateCardSignPers_POx_List,
        dataItem_SignCard: state.soutState.RateCardSignPers_POx_SignCard,
        dataItem_UnSignCard: state.soutState.RateCardSignPers_POx_UnSignCard,
        dataItem_ViewCard: state.soutState.RateCardSignPers_POx_GetCardScan
    }
}
export default connect(mapStateToProps)(SoutCards)